const baseURL = 'https://variedadesmoria.digitalsbrands.com/';

export default baseURL;
